import { render, staticRenderFns } from "./StageTest.vue?vue&type=template&id=17200614&scoped=true&"
import script from "./StageTest.vue?vue&type=script&lang=js&"
export * from "./StageTest.vue?vue&type=script&lang=js&"
import style0 from "./StageTest.vue?vue&type=style&index=0&id=17200614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17200614",
  null
  
)

component.options.__file = "StageTest.vue"
export default component.exports